import { render, staticRenderFns } from "./InfoCardSponsorships.vue?vue&type=template&id=29409962&scoped=true&"
import script from "./InfoCardSponsorships.vue?vue&type=script&lang=js&"
export * from "./InfoCardSponsorships.vue?vue&type=script&lang=js&"
import style0 from "./InfoCardSponsorships.vue?vue&type=style&index=0&id=29409962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29409962",
  null
  
)

export default component.exports